import { useEffect, useState } from "react";
//import './inicio.css'
//import './nosotros.css'

function Sucursales() {
    /*const [sucursales, setSucursales] = useState([])
    const getSucursales = () => {
        ConsultaData(`web/getSucursales`)
            .then(response => {
                setSucursales(response)
            })
    }
    useEffect(() => {
        getSucursales()
    }, [])*/
    //titulo y subtitulo
    return (
        <div className=" py-5 container">
            <h3>Nuestros Locales</h3><hr />
            <div className="row" data-bs-spy="scroll" data-bs-target="#navbar-example">

                <div className="card">
                    <div className="card-header">
                        Arequipa
                    </div>
                    <div className="card-body">
                        <h5 className="card-title">Sucursal 1</h5>
                        <p className="card-text">
                            Calle Nueva esquina con Víctor Lira - Cercado de Arequipa
                            (Para disfrutar en el local)
                        </p>
                        <span className="btn btn-primary">Telf. 054 424087</span>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Arequipa
                    </div>
                    <div className="card-body">
                        <h5 className="card-title">Sucursal 2</h5>
                        <p className="card-text">
                            Av. EEUU #14, Óvalo del Cementerio Apacheta - JLB y Rivero
                            (sólo para llevar)
                        </p>
                        <span className="btn btn-primary">Telf. 054 424087</span>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Arequipa
                    </div>
                    <div className="card-body">
                        <h5 className="card-title">Sucursal 3</h5>
                        <p className="card-text">
                            Prolongación Mariscal Castilla #1600, a una cuadra del puente Santa Rosa
                            (para consumo en local)
                        </p>
                        <span className="btn btn-primary">Telf. 054 424087</span>
                    </div>
                </div>
            </div>
            <hr />
            {/* {JSON.stringify(nosotros)} */}
        </div>
    );
}

export default Sucursales;
